import "./editEvent.css";
import React, { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import {
	EditIconUpdated,
	UsersIconUpdated,
	TimeIconUpdated,
	RepeatIconUpdated,
	// video,
	MenuIconUpdated,
} from "../../../assets";
import EmailInput from "../../Email/EmailInput";
import { SlEvent } from "react-icons/sl";
import { useAppContext } from "../../../context/AppContext";
import { LightLoader } from "../../../components";
import axiosInstance from "../../../services/api.service";

function EditEvent({ event, title, onClose, handleShowSuccessModal }) {
	const { getAllEvents, setLoadingAllEvents, showToastError } = useAppContext();
	const [updatedEvent, setUpdatedEvent] = useState(event);
	const [emails, setEmails] = useState(event?.participants);
	const [loading, setLoading] = useState(false);

	const [eventMode, setEventMode] = useState(event?.eventMode);

	const [allDay, setAllDay] = useState(event?.allDay);
	const [repeat, setRepeat] = useState(event?.recurring);

	const handleAllDaySwitch = () => {
		setAllDay(!allDay);
	};

	const handleRepeatSwitch = () => {
		setRepeat(!repeat);
	};

	const handleEventModeChange = (e) => {
		setEventMode(e.target.value);
	};

	const adjustTextareaHeight = () => {
		const textarea = document.getElementById("otherDetails");
		textarea.style.height = "auto";
		textarea.style.height = `${textarea.scrollHeight}px`;
	};

	useEffect(() => {
		adjustTextareaHeight();
	}, [updatedEvent.otherDetails]);

	// Handle form change:
	const handleFormChange = (e) => {
		setUpdatedEvent({
			...updatedEvent,
			[e.target.name]: e.target.value,
		});
	};

	// Handle Submit | Update existing event:
	const handleSaveEvent = async (e) => {
		e.preventDefault();
		setLoading(true);

		const formatted = {
			title: updatedEvent?.title,
			participants: emails,
			eventMode: eventMode,
			allDay: allDay,
			startTime: updatedEvent?.startTime,
			endTime: updatedEvent?.endTime,
			recurring: repeat,
			otherDetails: updatedEvent?.otherDetails,
			// meetingLink: updatedEvent?.meetingLink,
		};

		try {
			const res = await axiosInstance.put(
				`/api/v1/event/${updatedEvent?.id}`,
				formatted
			);

			if (res.status === 200) {
				setLoading(false);
				handleShowSuccessModal();
				getAllEvents();
			}
		} catch (error) {
			const errMsg = error?.response?.data?.message;
			showToastError(errMsg);
			setLoading(false);
		}

		setLoadingAllEvents(false);
	};

	return (
		<>
			<div className="edit_event_container">
				<div className="edit_modal_event_header">
					<h1>{title}</h1>
					<IoClose className="edit_modal_event_close_icon" onClick={onClose} />
				</div>

				<form className="edit_modal_event_body" onSubmit={handleSaveEvent}>
					<div className="edit_modal_title">
						<img src={EditIconUpdated} alt="Edit Icon" />
						<input
							className="form_input edit"
							type="text"
							name="title"
							value={updatedEvent?.title}
							onChange={handleFormChange}
						/>
					</div>

					<div className="edit_modal_users">
						<img src={UsersIconUpdated} alt="Users Icon" />

						<EmailInput emails={emails} setEmails={setEmails} />
					</div>

					<div className="edit_modal_events">
						<SlEvent className="SlEvent edit" />
						<div className="edit_modal_event_inner">
							<p>Event</p>
							<div className="radio_groups_wrapper">
								<div className="radio_group">
									<input
										type="radio"
										id="internal"
										name="eventMode"
										value="internal"
										checked={eventMode === "internal"}
										onChange={handleEventModeChange}
									/>
									<label htmlFor="internal">Internal</label>
								</div>
								<div className="radio_group">
									<input
										type="radio"
										id="external"
										name="eventMode"
										value="external"
										checked={eventMode === "external"}
										onChange={handleEventModeChange}
									/>
									<label htmlFor="external">External</label>
								</div>
							</div>
						</div>
					</div>

					<div className="edit_modal_time">
						<img src={TimeIconUpdated} alt="Time Icon" />
						<div className="edit_modal_time_inner">
							<div className="edit_modal_time_inner_start_time">
								<p>All Day</p>
								<div
									className={`all_day_switch_container ${allDay}`}
									onClick={handleAllDaySwitch}
								>
									<span className={`all_day_switch ${allDay}`}></span>
								</div>
							</div>
							<div className="edit_modal_time_inner_start_time">
								<p>Start time</p>
								<input
									className="form_input time_edit"
									type="datetime-local"
									name="startTime"
									defaultValue={updatedEvent?.startTime.slice(0, 16)}
									onChange={handleFormChange}
								/>
							</div>
							<div className="edit_modal_time_inner_end_time">
								<p>End time</p>
								<input
									className="form_input time_edit"
									type="datetime-local"
									name="endTime"
									defaultValue={updatedEvent?.endTime.slice(0, 16)}
									onChange={handleFormChange}
								/>
							</div>
						</div>
					</div>

					<div className="edit_modal_repeat">
						<img src={RepeatIconUpdated} alt="Repeat Icon" />
						<div className="edit_modal_repeat_inner">
							<p>Repeat</p>
							<div
								className={`repeat_switch_container ${repeat}`}
								onClick={handleRepeatSwitch}
							>
								<span className={`repeat_switch ${repeat}`}></span>
							</div>
						</div>
					</div>

					{/* <div className="edit_modal_menu edit">
						<img src={MenuIconUpdated} alt="Menu Icon" />
						<div className="edit_modal_menu_inner">
							<span>
								<h3>Teams Meeting Link</h3>
								<img src={video} alt="Video Icon" />
							</span>
							<input
								className="form_input edit"
								type="url"
								name="meetingLink"
								value={updatedEvent?.meetingLink}
								onChange={handleFormChange}
							/>
							<textarea
								className="form_textarea edit"
								type="text"
								name="otherDetails"
								id="otherDetails"
								value={updatedEvent?.otherDetails}
								onChange={handleFormChange}
							/>
						</div>
					</div> */}

					<div className="edit_modal_menu edit">
						<img src={MenuIconUpdated} alt="Menu Icon" />
						<div className="edit_modal_menu_inner">
							<span>
								<h3>Other Details</h3>
							</span>
							<textarea
								className="form_textarea edit"
								type="text"
								name="otherDetails"
								id="otherDetails"
								value={updatedEvent?.otherDetails}
								onChange={handleFormChange}
							/>
						</div>
					</div>

					<div className="edit_modal_button">
						<button className="edit_modal_save_button">
							{loading ? <LightLoader /> : "Save"}
						</button>
					</div>
				</form>
			</div>
		</>
	);
}

export default EditEvent;
